module.exports = __webpack_public_path__ + "static/cike-175dbf6ca98378b76045df55447c6095.jpg";